this.BC = this.BC || {};

window.blurToCurrency = function(decimal_places, fieldnames) {
    for (let i = 0; i < fieldnames.length; i++) {
        let fieldname = fieldnames[i];
        const field = document.querySelector(fieldname);
        if (field) {
            field.addEventListener('blur', function() {
                if (this.value !== '') {
                    this.value = NumberHelpers.number_to_currency(this.value.replace(/[^\d.-]/g, ''), {precision: decimal_places});
                }
            });
        }
    }
};

window.blurToPercentage = function(decimal_places, fieldnames) {
    for (let i = 0; i < fieldnames.length; i++) {
        let fieldname = fieldnames[i];
        const field = document.querySelector(fieldname);
        if (field) {
            field.addEventListener('blur', function() {
                if (this.value !== '') {
                    this.value = NumberHelpers.number_to_percentage(this.value.replace(/[^\d.-]/g, ''), {precision: decimal_places});
                }
            });
        }
    }
};

window.addOrRemoveFields = function() {
    // Add event listeners using event delegation to avoid duplicates
    // Remove existing event listeners first
    document.removeEventListener('click', handleRemoveFields);
    document.removeEventListener('click', handleAddFields);
    
    // Add new event listeners
    document.addEventListener('click', handleRemoveFields);
    document.addEventListener('click', handleAddFields);
};

// Helper functions for event handling
function handleRemoveFields(event) {
    if (event.target.matches('.remove_fields')) {
        const hiddenInput = event.target.previousElementSibling;
        if (hiddenInput && hiddenInput.type === "hidden") {
            hiddenInput.value = "1";
        }
        const fieldsContainer = event.target.closest('.fields');
        if (fieldsContainer) {
            fieldsContainer.style.display = 'none';
        }
        event.preventDefault();
    }
}

function handleAddFields(event) {
    if (event.target.matches('.add_fields')) {
        const time = new Date().getTime();
        const dataId = event.target.dataset.id;
        const dataFields = event.target.dataset.fields;
        
        if (dataId && dataFields) {
            const regexp = new RegExp(dataId, "g");
            const newFields = dataFields.replace(regexp, time);
            event.target.insertAdjacentHTML('beforebegin', newFields);
        }
        event.preventDefault();
    }
}

window.setCookie = function(key, value) {
    let expires = new Date();
    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
    document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
};

window.getCookie = function(key) {
    let keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
    return keyValue ? keyValue[2] : null;
};